<template>
  <div v-if="renderQuestion(0)">
    <br>
    <div class="ui dividing sub header">Exit Survey</div>
    <div class="required field" style="margin-bottom:0;" v-if="renderQuestion(1)">
      <label class="german">Anzahl Coaching Calls, die der Teilnehmer erhalten hat</label>
      <label>Number of coaching calls received</label>
      <input type="number" v-model="end.end1" id="end-1">
    </div>
    <div class="required field" v-if="renderQuestion(2)">
      <br>
      <label class="german">Anzahl Coaching Calls, die der Teilnehmer erhalten hat</label>
      <label>Wenn Sie sich Ihr Migräne-Management ansehen, wie hilfreich waren das Coaching durch bzw. die Telefongespräche mit dem Gesundheitscoach?</label>
      <select class="ui search fluid dropdown" v-model="end.end2" id="end-2">
        <option value="">Please choose one</option>
        <option value="1"><span class="german">1 Außerordentlich hilfreich</span> | 1 Extremely helpful</option>
        <option value="2"><span class="german">2 Sehr hilfreich</span> | 2 Very helpful</option>
        <option value="3"><span class="german">3 Etwas hilfreich</span> | 3 Somewhat helpful</option>
        <option value="4"><span class="german">4 Nur ein bisschen hilfreich</span> | 4 Slightly helpful</option>
        <option value="5"><span class="german">5 Überhaupt nicht hilfreich</span> | 5 Not at all helpful</option>
      </select>
    </div>
    <div class="required field" v-if="renderQuestion(3)">
      <br>
      <label class="german">Wie hilfreich war der Aktionsplan?</label>
      <label>How helpful was the action plan?</label>
      <select class="ui search fluid dropdown" v-model="end.end3" id="end-3">
        <option value="">Please choose one</option>
        <option value="1"><span class="german">1 Außerordentlich hilfreich</span> | 1 Extremely helpful</option>
        <option value="2"><span class="german">2 Sehr hilfreich</span> | 2 Very helpful</option>
        <option value="3"><span class="german">3 Etwas hilfreich</span> | 3 Somewhat helpful</option>
        <option value="4"><span class="german">4 Nur ein bisschen hilfreich</span> | 4 Slightly helpful</option>
        <option value="5"><span class="german">5 Überhaupt nicht hilfreich</span> | 5 Not at all helpful</option>
      </select>
    </div>

    <div class="required field" v-if="renderQuestion(4)">
      <br>
      <label class="german">Wie hilfreich war der Lernplan?</label>
      <label>How helpful was the educational material?</label>
      <select class="ui search fluid dropdown" v-model="end.end4" id="end-4">
        <option value="">Please choose one</option>
        <option value="1"><span class="german">1 Außerordentlich hilfreich</span> | 1 Extremely helpful</option>
        <option value="2"><span class="german">2 Sehr hilfreich</span> | 2 Very helpful</option>
        <option value="3"><span class="german">3 Etwas hilfreich</span> | 3 Somewhat helpful</option>
        <option value="4"><span class="german">4 Nur ein bisschen hilfreich</span> | 4 Slightly helpful</option>
        <option value="5"><span class="german">5 Überhaupt nicht hilfreich</span> | 5 Not at all helpful</option>
      </select>
    </div>

    <div class="required field" v-if="renderQuestion(5)">
      <br>
      <label class="german">Wie hilfreich war die Migraine Buddy App?</label>
      <label>How helpful was the Migraine Buddy app ?</label>
      <select class="ui search fluid dropdown" v-model="end.end5" id="end-5">
        <option value="">Please choose one</option>
        <option value="1"><span class="german">1 Außerordentlich hilfreich</span> | 1 Extremely helpful</option>
        <option value="2"><span class="german">2 Sehr hilfreich</span> | 2 Very helpful</option>
        <option value="3"><span class="german">3 Etwas hilfreich</span> | 3 Somewhat helpful</option>
        <option value="4"><span class="german">4 Nur ein bisschen hilfreich</span> | 4 Slightly helpful</option>
        <option value="5"><span class="german">5 Überhaupt nicht hilfreich</span> | 5 Not at all helpful</option>
      </select>
    </div>

    <div class="required field" v-if="renderQuestion(6)">
      <br>
      <label class="german">Seit Programbeginn, wie sehr hat sich Ihre Migräne verbessert?</label>
      <label>Since the start of the program, how much has your migraine has improved? </label>
      <select class="ui search fluid dropdown" v-model="end.end6" id="end-6">
        <option value="">Please choose one</option>
        <option value="1"><span class="german">1 Außerordentlich verbessert</span> | 1 Very much improved</option>
        <option value="2"><span class="german">2 Sehr verbessert</span> | 2 Much improved</option>
        <option value="3"><span class="german">3 Leicht verbessert</span> | 3 Minimally improved</option>
        <option value="4"><span class="german">4 Keine Veränderung</span> | 4 No change</option>
        <option value="5"><span class="german">5 Leicht verschlechtert</span> | 5 Minimally worse</option>
        <option value="6"><span class="german">6 Sehr verschlechtert</span> | 6 Much worse</option>
        <option value="7"><span class="german">7 Außerordentlich verschlechtert</span> | 7 Very much worse</option>
      </select>
    </div>
    <div class="required field" v-if="renderQuestion(7)">
      <br>
      <label class="german">Haben Sie Fortschritte gemacht und sind Ihren Zielen nähergekommen, die Sie in Bezug auf Ihr Migräne-Management hatten?</label>
      <label>Did you make progress toward the goals you had around managing your migraine?</label>
      <select class="ui search fluid dropdown" v-model="end.end7" id="end-7">
        <option value="">Please choose one</option>
        <option value="1"><span class="german">1 Außerordentlich</span> | 1 Very much so</option>
        <option value="2"><span class="german">2 Sehr</span> | 2 Much</option>
        <option value="3"><span class="german">3 Etwas</span> | 3 Somewhat</option>
        <option value="4"><span class="german">4 Nur ein bisschen</span> | 4 Only slightly</option>
        <option value="5"><span class="german">5 Gar nicht</span> | 5 None</option>
      </select>
    </div>

    <div class="required field" v-if="renderQuestion(8)">
      <br>
      <label class="german">Welche Massnahmen haben Sie gegebenenfalls durch das Programm für Ihre Migräne umgesetzt?</label>
      <label>What actions, if any, have you implemented through the programme for your migraine? Please select all that apply. </label>
      <select multiple class="ui search fluid dropdown" v-model="end.end8" id="end-8">
        <option value="">Please select all that apply</option>
        <option value="1"><span class="german">1 Bereitete mich auf Arztbesuch vor</span> | 1. Prepared for HCP visit</option>
        <option value="2"><span class="german">2 Verbesserte Verhältnis zum Arzt</span> | 2. Improved relationship with HCP</option>
        <option value="3"><span class="german">3 Verstehen meine Migräne besser </span> | 3. Better understand my migraine</option>
        <option value="4"><span class="german">4 Kann meine Migräne und Medikation besser regeln</span> | 4. Better manage my migraine and medication</option>
        <option value="5"><span class="german">5 Machte Veränderungen an meinem Lebensstil</span> | 5. Made lifestyle changes</option>
        <option value="6"><span class="german">6 Kann über meine Migräne sprechen</span> | 6. Able to talk about my migraine</option>
        <option value="7"><span class="german">7 Kann meine Migräne auf der Arbeit regeln</span> | 7.Able to manage migraine at work</option>
        <option value="8"><span class="german">8 Anderes</span> | 8. Other</option>
      </select>
    </div>

    <div class="required field" v-if="renderQuestion(9)">
      <br>
      <label class="german">Haben Sie den Eindruck, dass das Programm Ihnen dabei geholfen hat, mit Ihrer Migräne besser umzugehen?</label>
      <label>Do you feel the programme has helped you better manage your migraine?</label>
      <select class="ui search fluid dropdown" v-model="end.end9" id="end-9">
        <option value="">Please choose one</option>
        <option value="1"><span class="german">1 Außerordentlich</span> | 1 Very much so</option>
        <option value="2"><span class="german">2 Sehr</span> | 2 Much</option>
        <option value="3"><span class="german">3 Etwas</span> | 3 Somewhat</option>
        <option value="4"><span class="german">4 Nur ein bisschen</span> | 4 Only slightly</option>
        <option value="5"><span class="german">5 Gar nicht</span> | 5 None</option>
      </select>
    </div>

    <div class="required field" style="margin-bottom:0;" v-if="renderQuestion(10)">
      <br>
      <label class="german">Wie wahrscheinlich ist es, dass Sie unser Programm einem anderen Mitarbeiter, einem Familienmitglied oder Freund mit Migräne weiterempfehlen würden? </label>
      <label>How likely is it that you would recommend our program to another employee, family member or friend with migraine? </label>
      <select class="ui search dropdown" v-model="end.end10" id="end-10">
        <option value="">Please choose one</option>
        <option value="0"><span class="german">0 Nicht wahrscheinlich es weiterzuempfehlen</span> | 0 Not likely to recommend</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
        <option value="9">9</option>
        <option value="10"><span class="german">10 Sehr wahrscheinlich es zu weiterzuempfehlen</span> | 10 Extremely likely to recommend</option>
      </select>
    </div>

    <div class="required field" v-if="renderQuestion(11)">
      <br>
      <label class="german">Wie beurteilen Sie die Leistung des Programms insgesamt in Bezug auf Ihre Erwartungen?</label>
      <label>Overall, how did the program perform in regards to your expectations? </label>
      <select class="ui search fluid dropdown" v-model="end.end11" id="end-11">
        <option value="">Please choose one</option>
        <option value="1"><span class="german">1 Übersteigt Erwartungen sehr</span> | 1. Greatly exceeded expectations</option>
        <option value="2"><span class="german">2 Übersteigt Erwartungen</span> | 2. Exceeded expectations</option>
        <option value="3"><span class="german">3 Entspricht Erwartungen</span> | 3. Matched expectations</option>
        <option value="4"><span class="german">4 Weniger als erwartet</span> | 4. Less than expected</option>
        <option value="5"><span class="german">5 Sehr viel weniger als erwartet</span> | 5. Much less than expected</option>
      </select>
    </div>

    <div class="required field" v-if="renderQuestion(12)">
      <br>
      <label class="german">Falls der Teilnehmer das Programm vor Ende eines Zeitraums von 6 Monaten beendet hat: Was war der Grund?</label>
      <label>If participant finished program earlier than 6 months: What was the reason? </label>
      <select class="ui search fluid dropdown" v-model="end.end12" id="end-12">
        <option value="">Please choose one</option>
        <option value="7"><span class="german">Nicht zutreffend</span> | N/A</option>
        <option value="1"><span class="german">Zustand verbessert und Programm nicht mehr benötigt</span> | Improved and didn't need programme </option>
        <option value="2"><span class="german">Programm war nicht wie erwartet</span> | Too much time needed to participate</option>
        <option value="3"><span class="german">Programm war nicht wie erwartet</span> | Programme wasn't as expected</option>
        <option value="4"><span class="german">Wechselte die Firma / verließ Novartis</span> | Moved company / left Novartis</option>
        <option value="5"><span class="german">Kein Grund angegeben / unbekannt</span> | No reason given / unknown</option>
        <option value="6"><span class="german">Anderes</span> | Other</option>
      </select>
    </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
			  end: {
          end1: null,
          end2: null,
          end3: null,
          end4: null,
          end5: null,
          end6: null,
          end7: null,
          end8: [],
          end9: null,
          end10: null,
          end11: null,
          end12: null
        }
      }
		},
		computed: {
		  showableQuestions: function(){
        switch (this.$route.params.checkpoint){
          case 'dayminus30':
            return [];
          case 'day0':
            return [];
          case 'day90':
            return [];
          case 'day180':
            return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
          case 'day270':
            return [0, 6,7,8,9,10];
          default:
            return [];
        }
      }
    },
		methods: {
		  renderQuestion: function(questionid) {
		    if (this.showableQuestions.indexOf(parseInt(questionid)) > -1) {
		      return true
        }
        return false
      }
    },
		mounted() {
		  $('.ui.dropdown').dropdown();
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/assessment/QnEnd.vue